"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newfoundlandCities = void 0;
exports.newfoundlandCities = [
    {
        label: "Aguathuna",
        value: 9,
    },
    {
        label: "Badger",
        value: 2,
    },
    {
        label: "Baie de Verde",
        value: 4,
    },
    {
        label: "Baie Verte",
        value: 6,
    },
    {
        label: "Bauline",
        value: 67,
    },
    {
        label: "Bay L'Argent",
        value: 11,
    },
    {
        label: "Bay Roberts",
        value: 8,
    },
    {
        label: "Bell Island",
        value: 13,
    },
    {
        label: "Belleoram",
        value: 10,
    },
    {
        label: "Benoit's Cove",
        value: 15,
    },
    {
        label: "Bishop's Falls",
        value: 12,
    },
    {
        label: "Bonavista",
        value: 14,
    },
    {
        label: "Botwood",
        value: 16,
    },
    {
        label: "Brigus",
        value: 18,
    },
    {
        label: "Buchans",
        value: 54,
    },
    {
        label: "Burgeo",
        value: 20,
    },
    {
        label: "Burin",
        value: 22,
    },
    {
        label: "Burl.-Green Bay",
        value: 17,
    },
    {
        label: "Cape Broyle",
        value: 94,
    },
    {
        label: "Carbonear",
        value: 24,
    },
    {
        label: "Carmanville",
        value: 284,
    },
    {
        label: "Catalina",
        value: 26,
    },
    {
        label: "Cavendish",
        value: 55,
    },
    {
        label: "Change Islands",
        value: 28,
    },
    {
        label: "Channel-Port aux Basques",
        value: 30,
    },
    {
        label: "Chapel Cove",
        value: 56,
    },
    {
        label: "Clarenville",
        value: 32,
    },
    {
        label: "Clark's Beach",
        value: 34,
    },
    {
        label: "Come By Chance",
        value: 40,
    },
    {
        label: "Conception Bay",
        value: 19,
    },
    {
        label: "Cormack",
        value: 21,
    },
    {
        label: "Corner Brook",
        value: 36,
    },
    {
        label: "Cow Head",
        value: 23,
    },
    {
        label: "Creston, NL",
        value: 68,
    },
    {
        label: "Cupids",
        value: 38,
    },
    {
        label: "Deer Lake",
        value: 42,
    },
    {
        label: "Doyles",
        value: 25,
    },
    {
        label: "Dunnville, NL",
        value: 44,
    },
    {
        label: "Durrell",
        value: 57,
    },
    {
        label: "Eastport",
        value: 58,
    },
    {
        label: "Elliston",
        value: 50,
    },
    {
        label: "Englee",
        value: 52,
    },
    {
        label: "Flowers Cove, NL",
        value: 3,
    },
    {
        label: "Fogo",
        value: 60,
    },
    {
        label: "Forteau",
        value: 69,
    },
    {
        label: "Fortune",
        value: 62,
    },
    {
        label: "Freshwater",
        value: 64,
    },
    {
        label: "Gambo",
        value: 27,
    },
    {
        label: "Gander",
        value: 80,
    },
    {
        label: "Gaultois",
        value: 82,
    },
    {
        label: "Gillams",
        value: 29,
    },
    {
        label: "Glenwood, NL",
        value: 84,
    },
    {
        label: "Glovertown",
        value: 86,
    },
    {
        label: "Goose Bay",
        value: 87,
    },
    {
        label: "Gould",
        value: 281,
    },
    {
        label: "Grand Bank",
        value: 88,
    },
    {
        label: "Grand Falls, NL",
        value: 90,
    },
    {
        label: "Greenspond",
        value: 92,
    },
    {
        label: "Hants Harbour",
        value: 95,
    },
    {
        label: "Happy Valley",
        value: 100,
    },
    {
        label: "Harbour Breton",
        value: 102,
    },
    {
        label: "Harbour Grace",
        value: 104,
    },
    {
        label: "Hare Bay",
        value: 106,
    },
    {
        label: "Hawke's Bay",
        value: 31,
    },
    {
        label: "Holyrood",
        value: 108,
    },
    {
        label: "Hopedale",
        value: 285,
    },
    {
        label: "Jackson's Arm",
        value: 33,
    },
    {
        label: "Jerseyside",
        value: 114,
    },
    {
        label: "Kelligrews",
        value: 35,
    },
    {
        label: "Kilbride, NL",
        value: 37,
    },
    {
        label: "Labrador City",
        value: 120,
    },
    {
        label: "Lamaline",
        value: 122,
    },
    {
        label: "Lawn",
        value: 124,
    },
    {
        label: "Lewisporte",
        value: 126,
    },
    {
        label: "Little Catalina",
        value: 128,
    },
    {
        label: "Lourdes, NL",
        value: 5,
    },
    {
        label: "Lumsden, NL",
        value: 130,
    },
    {
        label: "Main Brook",
        value: 140,
    },
    {
        label: "Makkovik",
        value: 286,
    },
    {
        label: "Manuels",
        value: 283,
    },
    {
        label: "Mary's Harbour",
        value: 287,
    },
    {
        label: "Marystown",
        value: 142,
    },
    {
        label: "Milltown, NL",
        value: 39,
    },
    {
        label: "Mount Pearl",
        value: 228,
    },
    {
        label: "Nain",
        value: 288,
    },
    {
        label: "Natuashish",
        value: 289,
    },
    {
        label: "Newtown",
        value: 230,
    },
    {
        label: "Norris Arm",
        value: 156,
    },
    {
        label: "Old Pelican",
        value: 160,
    },
    {
        label: "O'Regans",
        value: 41,
    },
    {
        label: "Other",
        value: 299,
    },
    {
        label: "Outer Cove",
        value: 59,
    },
    {
        label: "Paradise, NL",
        value: 7,
    },
    {
        label: "Pasadena",
        value: 170,
    },
    {
        label: "Placentia",
        value: 172,
    },
    {
        label: "Point Leamington",
        value: 174,
    },
    {
        label: "Port au Choix",
        value: 66,
    },
    {
        label: "Port Rexton",
        value: 96,
    },
    {
        label: "Port Saunders",
        value: 45,
    },
    {
        label: "Port Union",
        value: 176,
    },
    {
        label: "Port-au-Port",
        value: 43,
    },
    {
        label: "Portugal Cove",
        value: 46,
    },
    {
        label: "Pouch Cove",
        value: 178,
    },
    {
        label: "Pound Cove",
        value: 290,
    },
    {
        label: "Ramea",
        value: 190,
    },
    {
        label: "Renews",
        value: 47,
    },
    {
        label: "Rigolet",
        value: 291,
    },
    {
        label: "Robert's Arm",
        value: 192,
    },
    {
        label: "Rocky Harbour",
        value: 292,
    },
    {
        label: "Roddickton",
        value: 194,
    },
    {
        label: "South Brook",
        value: 210,
    },
    {
        label: "South River, NL",
        value: 212,
    },
    {
        label: "Spaniard's Bay",
        value: 214,
    },
    {
        label: "Springdale",
        value: 216,
    },
    {
        label: "St Alban's, NL",
        value: 220,
    },
    {
        label: "St Anthony",
        value: 222,
    },
    {
        label: "St George's, NL",
        value: 224,
    },
    {
        label: "St John's, NL",
        value: 226,
    },
    {
        label: "St Lawrence",
        value: 236,
    },
    {
        label: "Stephenville",
        value: 240,
    },
    {
        label: "Stephenville Cros",
        value: 242,
    },
    {
        label: "Topsail",
        value: 48,
    },
    {
        label: "Torbay",
        value: 49,
    },
    {
        label: "Trepassey",
        value: 250,
    },
    {
        label: "Trinity",
        value: 282,
    },
    {
        label: "Triton",
        value: 51,
    },
    {
        label: "Twillingate",
        value: 252,
    },
    {
        label: "Upper Island Cove",
        value: 260,
    },
    {
        label: "Wabana",
        value: 270,
    },
    {
        label: "Wabush",
        value: 272,
    },
    {
        label: "Wesleyville",
        value: 274,
    },
    {
        label: "Western Bay",
        value: 53,
    },
    {
        label: "Whitbourne",
        value: 276,
    },
    {
        label: "Windsor, NL",
        value: 278,
    },
    {
        label: "Winterton",
        value: 280,
    },
    {
        label: "Witless Bay",
        value: 70,
    },
];
